import { render, staticRenderFns } from "./CatalogoRuta.vue?vue&type=template&id=a6f61eb8&scoped=true&"
import script from "./CatalogoRuta.vue?vue&type=script&lang=ts&"
export * from "./CatalogoRuta.vue?vue&type=script&lang=ts&"
import style0 from "./CatalogoRuta.vue?vue&type=style&index=0&id=a6f61eb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f61eb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VCarousel,VCarouselItem,VCol,VContainer,VIcon,VRow})
